import { render } from "./ComplianceTemplate.vue?vue&type=template&id=50a170b7&ts=true"
import script from "./ComplianceTemplate.vue?vue&type=script&lang=ts"
export * from "./ComplianceTemplate.vue?vue&type=script&lang=ts"

import "./ComplianceTemplate.vue?vue&type=style&index=0&id=50a170b7&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__